'use client';

import { useSignInStore } from '@/store/signInStore';
import { useStepUpStore } from '@/store/stepUpStore';

export const clearSessionState = () => {
  useSignInStore.persist.clearStorage();
  useStepUpStore.persist.clearStorage();
};
